module.exports = __webpack_public_path__ + "static/vishal-garg-400w-103018-9fb0bca99da2be6d1fbb846e8638c667.jpg";